<template>
  <v-dialog
    v-model="showVisible"
    :max-width="maxWidth"
    :persistent="persistent"
  >
    <v-card>
      <div class="dialog-title px-6 pt-4 pb-6">{{ title }}</div>
      <div v-if="content" class="dialog-content px-6 pb-4">
        {{ content }}
      </div>

      <div class="dialog-content px-6 pb-4">
        <slot />
      </div>

      <v-card-actions class="d-flex justify-end pb-3">
        <v-btn small color="#5C5C5C" text class="btn" @click="handleClose">
          {{ cancelText }}
        </v-btn>
        <v-btn
          v-if="needConfirmText"
          small
          :color="isWarn ? '#D92121' : '#0078D6'"
          text
          :loading="loading"
          :disabled="!confirmEnabled && loading"
          class="btn"
          @click="handleConfirm"
        >
          {{ showConfirmText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { defineComponent, computed } from 'vue'

export default defineComponent({
  name: 'BaseDialog',
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      default: '提醒',
    },
    content: {
      type: String,
      required: false,
      default: '',
    },
    confirmText: {
      type: String,
      default: '确认',
    },
    needConfirmText: {
      type: Boolean,
      default: true,
    },
    cancelText: {
      type: String,
      default: '取消',
    },
    cancelTextColor: {
      type: String,
      default: '#0078D6',
    },
    isWarn: {
      type: Boolean,
      default: false,
    },
    maxWidth: {
      type: [String, Number],
      default: '444px',
    },
    persistent: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    confirmEnabled: {
      type: Boolean,
      default: true,
    },
  },
  emits: ['update:visible', 'handleConfirm'],
  setup(props, { emit }) {
    const showVisible = computed({
      get() {
        return this.visible
      },
      set(value) {
        emit('update:visible', value)
      },
    })
    // 如果内容包含以下关键词，手动修改确认按钮文案
    const showConfirmText = computed(() => {
      const specialText = ['删除', '拒绝', '撤回', '限制', '移除', '下沉']
      for (let index = 0; index < specialText.length; index++) {
        const element = specialText[index]
        if (
          props?.content &&
          props.content.includes(element) &&
          !props.content.includes('取消限制') &&
          !props.content.includes('取消下沉')
        )
          return element
      }
      return props.confirmText
    })
    const handleClose = () => {
      showVisible.value = false
    }
    const handleConfirm = () => {
      emit('handleConfirm')
      // handleClose()
    }
    return { showVisible, showConfirmText, handleClose, handleConfirm }
  },
})
</script>

<style lang="scss" scoped>
.btn {
  font-size: 14px;
  font-weight: 600;
}
:deep(.v-dialog) {
  .dialog-title {
    font-weight: 600;
    font-size: 20px;
    color: rgba(0, 0, 0, 0.87);
  }
  .dialog-content {
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: rgba(0, 0, 0, 0.87);
  }
}

:deep(.v-dialog > .v-card > .v-card__title) {
  padding: 16px 24px;
  font-weight: 600;
  font-size: 20px;
  color: rgba(0, 0, 0, 0.87) !important;
}
</style>
